import requestV2 from '@/service/request-v2'

export interface EmployeeMessageCount {
  empUserId: string
  sendCount: number
  name: string
  groupName: string
}

export async function fetchEmployeeMessageCounts(
  params: { startDate: string; endDate: string },
  signal: AbortSignal
) {
  const data = await requestV2.get<EmployeeMessageCount[]>({
    url: '/api/statistics/smartchat/message-send-count',
    params,
    signal
  })
  if (
    !Array.isArray(data) ||
    !data.every(
      (row) =>
        row && typeof row.empUserId === 'string' && isCount(row.sendCount)
    )
  ) {
    throw new Error('员工消息统计返回数据格式异常，请重新加载')
  }
  return data
}

const isCount = (value: unknown) =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0

export interface AiAssistantOverview {
  startDate: string
  endDate: string
  summary: {
    tabVisit: {
      customerAnalysisCount: number
      userProfileCount: number
      chatAssistantCount: number
      totalCount: number
    }
    apiUsage: {
      scriptGenerateCount: number
      scriptOptimizeCount: number
      matchEightServicesCount: number
      totalCount: number
    }
    userUsage: { userCount: number }
  }
}

export async function fetchAiAssistantOverview(
  params: { startDate: string; endDate: string },
  signal: AbortSignal
): Promise<AiAssistantOverview> {
  const data = await requestV2.get<AiAssistantOverview>({
    url: '/api/statistics/smartchat/overview',
    params,
    signal
  })
  const summary = data?.summary
  if (
    ![
      summary?.tabVisit?.customerAnalysisCount,
      summary?.tabVisit?.userProfileCount,
      summary?.tabVisit?.chatAssistantCount,
      summary?.tabVisit?.totalCount,
      summary?.apiUsage?.scriptGenerateCount,
      summary?.apiUsage?.scriptOptimizeCount,
      summary?.apiUsage?.matchEightServicesCount,
      summary?.apiUsage?.totalCount,
      summary?.userUsage?.userCount
    ].every(isCount)
  ) {
    throw new Error('功能使用统计返回数据格式异常，请重新加载')
  }
  return data
}
